import SwitchButtonStyle from "./SwitchButton.module.scss";
import  * as React from "react";
import { observer } from "mobx-react";
import { action } from "mobx";
import {ISwitchButtonProps} from "./ISwitchButtonProps";

@observer
export class SwitchButton extends React.Component<ISwitchButtonProps>{
    constructor(props: ISwitchButtonProps) {
        super(props, undefined);
    }
    @action.bound
    displayStrokesGroup() {
        if (this.props.displayStrokesGroup) {
            this.props.displayStrokesGroup(this.props.groupIndex);
        }
    }
    
    render() {
        let switchContainer = {
            backgroundColor: this.props.measurementGroup.isSelected ? this.props.measurementGroup.color : '#c1c1c1'
        }
        let switchButton = {
            left: this.props.measurementGroup.isSelected ? '20px' : '1px'
        }
        let switchButtonText = { color: this.props.measurementGroup.isSelected ? this.props.measurementGroup.color : '#c1c1c1' }

        return <span className={SwitchButtonStyle.SwitchButton} onClick={() => this.displayStrokesGroup()}>
            <span className={SwitchButtonStyle.switchWrapper}>
                <span className={SwitchButtonStyle.switchBackground} style={switchContainer}></span>
                <span className={SwitchButtonStyle.clubTypeWrapper} style={switchButton}>
                    <span className={SwitchButtonStyle.abbreviatedClubTypeText} style={switchButtonText}>{this.props
                               .measurementGroup
                               .abbreviatedClubType}</span>
                       </span>
                   </span>
               </span>;
    }
}
